import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Session is held in HttpOnly cookies; bootstrap by asking the server who we are.
  // Skip the call for anonymous visitors (no readable pf_csrf cookie) to avoid a noisy 401.
  const refresh = useCallback(async () => {
    const hasSession = document.cookie.split("; ").some((c) => c.startsWith("pf_csrf="));
    if (!hasSession) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, remember = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data.user);
    return data.user;
  };

  const registerPartner = async (payload) => {
    const { data } = await api.post("/auth/register-partner", payload);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("logout request failed, clearing session locally", e); }
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, registerPartner, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
